import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AngularMaterialModule } from 'src/app/angular-material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ServiceOrdersTotalizersComponent } from './service-orders-totalizers.component';



@NgModule({
  declarations: [
    ServiceOrdersTotalizersComponent
  ],
  exports: [
    ServiceOrdersTotalizersComponent
  ],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FlexLayoutModule
  ]
})
export class ServiceOrdersTotalizersModule { }
